// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2tfD9","selects":"Documents_selects__1jgLA"};